/* eslint-disable */
import React from 'react';
import {
  Dialog, DialogContent, DialogActions, Divider,
  Box, Typography, Button,
} from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import AppButton from 'Shared/UI/Button';

/**
 * ConfirmReceptionDialog
 *
 * Props:
 *   open       {boolean}   Controls dialog visibility.
 *   onClose    {Function}  Called when the user cancels or closes.
 *   onConfirm  {Function}  Called when the user confirms reception.
 *
 * Position / size:
 *   Adjust `sx` on the Dialog or PaperProps below to reposition.
 *   - `sx={{ '& .MuiDialog-container': { alignItems: 'flex-start', pt: '120px' } }}`
 *     moves the dialog toward the top.
 *   - PaperProps › sx › `maxWidth` / `width` control the card size.
 */
const ConfirmReceptionDialog = ({ open, onClose, onConfirm, loading = false }) => {
  const handleConfirm = () => {
    onConfirm && onConfirm();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      /* ── Position ─────────────────────────────────────────────────
         Change alignItems ('center' | 'flex-start' | 'flex-end') and
         pt / pb to move the dialog vertically.
         Change justifyContent or ml/mr on the container to shift it
         horizontally.
      ──────────────────────────────────────────────────────────────── */
      sx={{
        '& .MuiDialog-container': {
          alignItems: 'center',
          pb: '280px',
        },
        '& .MuiBackdrop-root': {
          backgroundColor: 'rgba(0, 37, 59, 0.28)',
        },
      }}
      PaperProps={{
        sx: {
          borderRadius: '16px',
          p: '2px',
          mt:'-28px',
          ml:'-4px',
          maxWidth: '450px',
          width: '100%',
          height:'220px',
          fontFamily: "'Open Sans', sans-serif",
        },
      }}
    >
      <DialogContent sx={{ pb: '8px' }}>
        {/* Header */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '14px', mb: '16px' }}>
          <Box sx={{
            width: 44, height: 44, borderRadius: '50%',
            backgroundColor: '#E6FBF5',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            flexShrink: 0,
          }}>
            <CheckIcon sx={{ color: '#0AD69F', fontSize: 24 }} />
          </Box>
          <Typography sx={{ fontSize: '20px', fontWeight: 600, color: '#385576', fontFamily: "'Open Sans', sans-serif" }}>
            Confirmation de réception
          </Typography>
        </Box>
 
        <Typography sx={{ fontSize: '14px',fontWeight:400, color: '#8397AE', textAlign: 'left', px: '0px',lineHeight: 1.6, fontFamily: "'Open Sans', sans-serif" }}>
          Je confirme avoir reçu la marchandise mentionnée sur ce bon de livraison.
        </Typography>
      </DialogContent>

      <Divider sx={{ mx: '22px' ,borderBottomWidth: '2px', mb:'8px'}} />

      <DialogActions sx={{ px: '20px', pb: '20px', gap: '12px' }}>
        <Button
          onClick={onClose}
          variant="outlined"
          sx={{ flex: 1, borderRadius: '8px', textTransform: 'none', fontWeight: 600, fontSize: '14px', color: '#385576', borderColor: '#DEE5EE', height: '44px', fontFamily: "'Open Sans', sans-serif", '&:hover': { borderColor: '#B0BEC5', backgroundColor: 'transparent' } }}
        >
          Annuler
        </Button>
        <AppButton
          variant="custom"
          label="Confirmer la réception"
          color="#0AD69F"
          hoverColor="#08b886"
          textColor="#fff"
          loading={loading}
          onClick={handleConfirm}
          sx={{ flex: 1, borderRadius: '8px', textTransform: 'none', fontWeight: 600, fontSize: '13px', height: '44px', fontFamily: "'Open Sans', sans-serif" }}
        />
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmReceptionDialog;